import React from 'react';

const FormField = ({ 
  label, 
  error, 
  children, 
  required = false,
  className = "my-4" 
}) => {
  return (
    <div className={className}>
      {label && (
        <label className={`form-label text-dark ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      {children}
      {error && (
        <small className="text-danger d-block mt-1">{error}</small>
      )}
    </div>
  );
};

export default FormField;